<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="hpanel">

          <div class="panel-heading">
            Companies
          </div>
          <div class="panel-body">
            <div class="">
              <div class="table-responsive" style="border: 0">
                <table id="companiesDataTable" class="table table-striped table-bordered table-hover "
                       style="font-size: 10px;width: 100%">
                  <thead>
                  <tr>
                    <th></th>
                    <th>#Ref</th>
                    <th>Name</th>
                    <th>Category</th>
                    <th>Description</th>
                    <th>Industrial Classification</th>
                    <th>Keywords</th>
                    <th>Incorp. date</th>
                    <th>Nb patents</th>
                    <th>Nb Employees</th>
                    <th>City</th>
                    <th>Country</th>
                    <th>Website</th>
                    <th>Is Open for Collaboration</th>
                    <th>Open for Collaboration Changed date</th>
                    <th>Contact Name</th>
                    <th>Contact Position</th>
                    <th>Contact Phone</th>
                    <th>Contact Email</th>
                    <th>Logo</th>
                    <th>Files</th>
                    <th>Created</th>
                    <th>Status</th>
                    <th>Validation date</th>
                    <th>Validated By</th>
                    <th v-if="$auth.user().plan.account_provisioning === 1">Action</th>
                  </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .btnDisable, .btnEnable {
    font-size: 13px;
    padding: 0px 3px
  }

</style>

<script>
import 'datatables.net-select-bs/css/select.bootstrap.min.css'
import 'datatables.net-select-bs/js/select.bootstrap.min'

export default {
  components: {},
  props: [],
  name: 'CompaniesData',
  data () {
    return {
      dataTable: null,
      selectedRows: [],
      api_url: process.env.API_URL
    }
  },
  mounted () {
    let customColumnDefs = []
    if (this.$auth.user().plan.account_provisioning === 1) {
      customColumnDefs.push({
        targets: 25,
        data: null,
        searchable: false,
        defaultContent: '<router-link  class="btn btn-xs btn-block btn-info btn-outline editCompany">' +
          '<i class="fas fa-pencil-alt"></i> Edit </router-link><br> ' +
          '<router-link  class="btn btn-xs btn-block btn-success validateCompany"> Validate </router-link>'
      })
    }

    customColumnDefs.push({
      orderable: false,
      searchable: false,
      className: 'select-checkbox',
      targets: 0
    })

    this.dataTable = $('#companiesDataTable').DataTable({
      pageLength: 30,
      responsive: true,
      processing: true,
      serverSide: true,
      bPaginate: true,
      dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>t<'row'<'col-sm-3'i><'col-sm-6 text-center'p><'col-sm-3'>>",
      ajax: {
        url: process.env.API_URL + '/editData/companies?relations={keywords.keyword,files,country,industrialClassification,nbEmployees,category}',
        dataSrc: 'data',
        beforeSend: function (request) {
          request.setRequestHeader('Authorization', 'Bearer ' + localStorage.default_auth_token
          )
        }
      },
      columns: [
        {data: null, defaultContent: '', searchable: false, orderable: false},
        {data: 'id', searchable: true, orderable: true },
        {data: 'name'},
        {data: 'category', name: 'category', searchable: false, orderable: false},
        {data: 'activity_overview'},
        {data: 'industrial_classification', name: 'industrial_classification', searchable: false, orderable: false},
        {data: 'keywords', searchable: false, orderable: false}, // {data: 'keywords'},
        {data: 'incorporation_date'},
        {data: 'nb_employees', name: 'nb_employees', searchable: false, orderable: false},
        {data: 'nb_patents'},
        {data: 'city'},
        {data: 'country', name: 'country', searchable: false, orderable: false},
        {data: 'website'},
        {data: 'is_open_for_collaboration'},
        {data: 'is_open_for_collaboration_changed_at'},
        {data: 'contact_name'},
        {data: 'contact_position'},
        {data: 'contact_email'},
        {data: 'contact_phone'},
        {data: 'logo'},
        {data: 'files', searchable: false, orderable: false},
        {data: 'created_at'},
        {data: 'is_validated'},
        {data: 'validated_at'},
        {data: 'validated_by'}

      ],
      rowId: 'id',
      columnDefs: customColumnDefs,
      // 'stateSave': true,
      'select': true,
      createdRow: (row, data, index) => {
        let td = $('td', row).eq(13)
        if (data['is_open_for_collaboration'] * 1 > 0) {
          td.html('<span class="btn-success btnEnable"><i class="fa fa-check"></i></span>')
        } else {
          td.html('<span class="btn-danger btnDisable" ><i class="fa fa-times"></i></span>')
        }
        td.attr('align', 'center')
        td.css('vertical-align', 'middle')

        if (data['logo']) {
          td = $('td', row).eq(19)
          td.html('<img src="' + this.api_url + data['logo'] + '" width="100%" style="max-height: 70px">')
        }

        if (data['files']) {
          let urls = data['files'].split(';')
          let str = ''
          urls.forEach((item) => {
            str += '<a href="' + this.api_url + item + '" target="_blank"> <i>File link</i></a><br>'
          })
          let td = $('td', row).eq(20)
          td.html(str)
        }

        td = $('td', row).eq(22)
        if (data['is_validated']) {
          td.html('<b class="text-success">Validated</b>')
          $('td', row).eq(25).html('<a class="btn btn-xs btn-block btn-info btn-outline editCompany"><i class="fas fa-pencil-alt"></i> Edit </a>')
        } else {
          td.html('<b class="text-warning">Awaiting Validation</b>')
        }
      },
      initComplete: () => {
        this.manageSelects()
      },
      buttons: [
        {
          text: 'Select page',
          className: 'btn btn-xs btn-info btn-outline',
          action: () => {
            this.dataTable.rows({
              page: 'current'
            }).select()
          }
        },
        {
          text: 'Unselect All',
          className: 'btn btn-xs btn-info btn-outline',
          action: () => {
            this.selectedRows = []
            this.dataTable.rows().deselect()
          }
        }, {
          text: 'Validate All Select rows',
          className: 'btn btn-xs btn-info btn-outline',
          action: () => {
            this.validate(this.selectedRows)
          }
        }
      ]
    })

    $('#companiesDataTable tbody').on('click', '.editCompany', (e) => {
      e.stopPropagation()
      let data = this.dataTable.row($(e.target).parents('tr')).data()
      let routeData = this.$router.resolve({name: 'CompanyEdit', params: {company_id: data['id']}})
      window.open(routeData.href, '_blank')
    })

    $('#companiesDataTable tbody').on('click', '.validateCompany', (e) => {
      e.stopPropagation()
      let data = this.dataTable.row($(e.target).parents('tr')).data()
      this.validate([data['id']])
    })
  },
  methods: {
    getSelectedRows () {
      return this.selectedRows
    },
    manageSelects () {
      let $api = this.dataTable

      $api.on('select', (e, dt, type, indexes) => {
        indexes.forEach((index) => {
          let rowId = $api.row(index).data().id
          let exist = this.selectedRows.find(value => {
            return rowId === value
          })

          if (typeof exist === 'undefined') {
            this.selectedRows.push(rowId)
          }
        })
      })

      $api.on('deselect', (e, dt, type, indexes) => {
        indexes.forEach((index) => {
          let rowId = $api.row(index).data().id
          this.selectedRows = this.selectedRows.filter((value) => {
            return value !== rowId
          })
        })
      })

      $api.on('draw.dt', () => {
        this.selectedRows.forEach((id) => {
          $api.row('#' + id).select()
        })
      })
    },
    validate (companies_ids) {
      this.axios.patch('/editData/validate/companies', {
        companies_ids: companies_ids

      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Company Information is validated',
          placement: 'bottom-right'
        })

        this.dataTable.ajax.reload()
      }).catch((error) => {
        this.$notify({
          type: 'danger',
          title: 'An error has occurred',
          placement: 'bottom-right'
        })
      }).finally(() => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/validateData/CompaniesData.vue